import { z } from "zod";
/**
 * Messages consumed by the web SDK
 */ const WebSDKMessageSetClickPreventionSchema = z.object({
    name: z.literal("set-click-prevention"),
    preventing: z.boolean()
});
const WebSDKMessageExitEditingSchema = z.object({
    name: z.literal("exit-editing")
});
const WebSDKMessageExitPaywallSchema = z.object({
    name: z.literal("exit-paywall")
});
const WebSDKMessageResetHoverElementSchema = z.object({
    name: z.literal("reset-hover-element")
});
const WebSDKMessageSetHoverBoxSchema = z.object({
    name: z.literal("set-hover-box"),
    hoverBox: z.boolean()
});
const WebSDKMessageInitiatePurchase = z.object({
    name: z.literal("initiate-purchase"),
    context: z.object({
        webProductId: z.number(),
        stripePriceId: z.string()
    })
});
export const WebSDKMessageSchema = z.discriminatedUnion("name", [
    WebSDKMessageExitEditingSchema,
    WebSDKMessageExitPaywallSchema,
    WebSDKMessageSetClickPreventionSchema,
    WebSDKMessageResetHoverElementSchema,
    WebSDKMessageSetHoverBoxSchema,
    WebSDKMessageInitiatePurchase
]);
export const WrappedWebSDKMessageSchema = z.object({
    _type: z.literal("sw-web-sdk"),
    version: z.literal(1),
    events: z.array(WebSDKMessageSchema)
});
